import { render, staticRenderFns } from "./kw_avatar.vue?vue&type=template&id=86e2e23e&scoped=true&"
import script from "./kw_avatar.vue?vue&type=script&lang=js&"
export * from "./kw_avatar.vue?vue&type=script&lang=js&"
import style0 from "./kw_avatar.vue?vue&type=style&index=0&id=86e2e23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e2e23e",
  null
  
)

component.options.__file = "kw_avatar.vue"
export default component.exports